import SotbitSelect from '../default/index.js';

export default class SotbitSelectRadio extends SotbitSelect {
    constructor() {
        super();
        this.multiple = false;
        this.clearable = false;
        this._slotItems = [];
    }

    get type() {
        return 'select-one';
    }

    getSlotItems() {
        const nodes = this._optionsSlotRef?.value
            ? this._optionsSlotRef.value.assignedElements({ flatten: false })
            : Array.from(this.children);

        return nodes.filter((node) => {
            const name = node.nodeName;
            return name === 'SOTBIT-SELECT-RADIO-OPTION' || name === 'SOTBIT-SELECT-RADIO-GROUP';
        });
    }

    getOptionsFromSlot() {
        return this.getSlotItems().flatMap((node) => {
            if (node.nodeName === 'SOTBIT-SELECT-RADIO-OPTION') {
                return [node];
            }

            return Array.from(node.querySelectorAll('sotbit-select-radio-option'));
        });
    }

    willUpdate(changedProperties) {
        this.multiple = false;
        super.willUpdate(changedProperties);
    }

    show() {
        this._modal = this._createModal();

        document.addEventListener('click', this._handleDocumentClick);

        this._movedSlots = true;
        this._slotItems = this.getSlotItems();
        this._slotItems.forEach((item) => this._modal.appendChild(item));

        const handleClose = () => {
            this.removeAttribute('open');
        };

        this._modal.addEventListener('close', handleClose, { once: true });
        this._modal.addEventListener('remove', handleClose, { once: true });

        document.body.appendChild(this._modal);
        window.addEventListener('resize', this._handleResizeObserve);
    }

    hide() {
        this._movedSlots = true;
        this.open = false;

        if (this._modal) {
            this._modal.remove();
            this._modal = null;
            this._slotItems?.forEach((item) => this.appendChild(item));
        }

        document.removeEventListener('click', this._handleDocumentClick);
        window.removeEventListener('resize', this._handleResizeObserve);
    }

    _syncOptionsFromValue(newValue) {
        const previousClearable = this.clearable;
        this.clearable = true;
        super._syncOptionsFromValue(newValue);
        this.clearable = previousClearable;
    }

    selectOption(option, dispatchEvent = false) {
        super.selectOption(option, dispatchEvent);
        this.open = false;
    }
}
